import {Injectable} from '@angular/core';

const STORAGE_KEY = 'clea-hidden-requests';

@Injectable({
    providedIn: 'root'
})
export class HiddenRequestsService {

    hide(relationId: string): void {
        const ids = this.getHiddenIds();
        if (!ids.includes(relationId)) {
            ids.push(relationId);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
        }
    }

    unhide(relationId: string): void {
        const ids = this.getHiddenIds().filter(id => id !== relationId);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    }

    isHidden(relationId: string): boolean {
        return this.getHiddenIds().includes(relationId);
    }

    getHiddenIds(): string[] {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        } catch {
            return [];
        }
    }
}
